import { useConfig } from 'Context/ConfigContext';

const useGoToPurchase = (skuCode, utmData) => {
  const { purchaseUrl } = useConfig();
  let purchaseLink = purchaseUrl;
  purchaseLink = purchaseLink?.replace(':skuCode', skuCode);

  if (utmData && purchaseLink) {
    const { courseTitle, sectionTitle, subsectionTitle, utmMedium = 'Purchase' } = utmData || {};
    purchaseLink = purchaseLink.replaceAll(':courseTitle', encodeURIComponent(courseTitle));
    purchaseLink = purchaseLink.replace(':sectionTitle', encodeURIComponent(sectionTitle));
    purchaseLink = purchaseLink.replace(':subsectionTitle', encodeURIComponent(subsectionTitle));
    purchaseLink = purchaseLink.replace(':utmMedium', encodeURIComponent(utmMedium));
  }
  return { enablePurchaseUrl: !!purchaseUrl, purchaseUrl: purchaseLink };
};

export default useGoToPurchase;
